import { Checkbox, Col, DatePicker, Form, Icon, Input, InputNumber, Row } from 'antd'
import useFetchSelect from '../../../../elements/Hooks/useFetchSelect'
import Taxes from '../../../../elements/Taxes'
import { get, isEmpty } from 'lodash'
import React, { useState } from 'react'

import { compose } from 'recompose'
import { ProductApi } from '../../../../api/Product'
import ProductModal from '../../../../components/Main/Product/ProductModal'
import FormSectionTitle from '../../../../elements/FormSectionTitle'
import withSort from '../../../../elements/HOC/withSort'
import withSpinning from '../../../../elements/HOC/withSpinning'
import useFetchSelectUrl from '../../../../elements/Hooks/useFetchSelectUrl'
import useModalData from '../../../../elements/Hooks/useModalData'
import InfoTooltip from '../../../../elements/InfoTooltip'
import MaterialDetails from '../../../../elements/MaterialDetails'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import UOM from '../../../../elements/Select/UOM'
import withSelectFetch from '../../../../elements/Select/withSelectFetch'
import SuggestedVendors from '../../../../elements/SuggestedVendors'
import {
  defaultFormItemLayout,
  fullWidthFormItemLayout,
  rules,
  threeFormItemLayout,
} from '../../../../modules/FormItems'
import { dateVal } from '../../../../modules/Utils'
import * as moment from "moment";

const { TextArea } = Input

const DeliveryTypeSelect = compose(
  withSelectFetch({
    dropdown: 'enquiry',
    name: 'delivery',
  }),
  withSpinning,
  withSort
)(CustomSelect)
const DeliveryServiceTypeSelect = compose(
  withSelectFetch({
    dropdown: 'enquiry',
    name: 'deliveryService',
  }),
  withSpinning,
  withSort
)(CustomSelect)

function EnquiriesLinesForm(props) {
  const { list, line, enquiry, company } = props

  const Max = Math.max(...list.map((o) => o.no), 0) + 1

  const { getFieldValue, getFieldDecorator, getFieldsValue, setFieldsValue, resetFields } = props.form
  const [categoryObj, setCategoryObj] = useState({})
  // console.log({ categoryObj })

  const a = moment(get(enquiry,'delivery.date'))
  const b = moment(get(enquiry,'cpo.date'))
  const deliveryDays = a.diff(b, 'days')

  const type = enquiry.enquiryType
  const product = getFieldValue('product._id') || get(line, 'product._id')
  const category = getFieldValue('category._id') || get(line, 'category._id')
  const group = getFieldValue('group._id') || get(line, 'group._id')
  const productType = getFieldValue('product._id') || get(line, 'product._id')

  const categoryUrl = `products/categories/dropdown?owner=${company._id}&type=${enquiry.enquiryType}&select=*`
  const [CategorySelect] = useFetchSelectUrl(
    {
      name: 'products_categories',
      url: categoryUrl,
      forceFetch: true,
    },
    [categoryUrl]
  )
  const groupUrl = `products/groups/dropdown?owner=${enquiry.company._id}&category=${category}&select=*`
  const [GroupsSelect] = useFetchSelectUrl(
    {
      name: 'products_groups',
      url: groupUrl,
    },
    [groupUrl],
    isEmpty(category)
  )

  // function onSelectCategory(value) {
  //   const category = sessionItem(
  //     `products_categories_${categoryUrl}_dropdown`,
  //     value,
  //     '_id',
  //   )
  //   setCategoryObj(category || {})
  // }
  //
  // useEffect(() => {
  //   onSelectCategory(category)
  // }, [])

  const {
    visible,
    modalType,
    object: productDB,
    submitting,
    submit,
    removing,
    remove,
    formRef,
    onShow,
    onCancel,
    update,
    setObject: setProduct,
  } = useModalData(ProductApi.create, ProductApi.update, ProductApi.remove, () => [])

  const productTypeUrl = `products/?owner=${enquiry.company._id}&category=${category}&group=${group}&state=Active&select=*`
  const { SelectData: ProductsTypeSelect, selected: productData } = useFetchSelect({
    url: productTypeUrl,
    dependencyArray: [productTypeUrl],
    dontFetch: isEmpty(productTypeUrl),
  })

  //isStocked

  const productsUrl = `products/lines?product=${product}&select=*`
  const { SelectData: ProductsSelect, selected: productLineData = {} } = useFetchSelect({
    url: productsUrl,
    dependencyArray: [productsUrl],
    dontFetch: isEmpty(productsUrl),
  })
  const defaultRate = productLineData && productLineData.price !== undefined && true ? productLineData.price : 0

  console.log({productData})
  console.log({productLineData})
  const isStocked = get(productData, 'isStocked') === true || get(productData, 'isFreight') === true
  const isService = get(productData, 'isService') === true

  React.useEffect(() => {
    if (productLineData) {
      const rate = getFieldValue('rate') || get(line, 'rate') || defaultRate
      const unit = getFieldValue('unit') || get(line, 'unit', 1)
      const tax = {
        percentage: get(line, 'tax.percentage') || get(enquiry,'taxType') === 'ex-tax' ? null : get(productLineData, 'tax.percentage'),
        rate: get(line, 'tax.rate') || get(enquiry,'taxType') === 'ex-tax' ? null : (get(productLineData, 'tax.percentage') / 100) * (rate || 0),
        type: get(line, 'tax.type') || get(enquiry,'taxType') === 'ex-tax' ? null : get(productLineData, 'tax.type'),
      }
      //console.log({ tax })

      setFieldsValue({
        name: get(line, 'name') || productLineData.name,
        description: get(line, 'description') || productLineData.description,
        unit,
        uom: get(line, 'uom.code') || productLineData.uom,
        rate,
        tax,
        taxType: get(line, 'taxType') || get(enquiry,'taxType') === 'ex-tax' ? 'ex-tax' : productLineData.tax ? 'inc-tax' : 'ex-tax',
      })

      /* console.log(
        get(line, 'tax.percentage') || get(productLineData, 'tax.percentage'),
        get(line, 'tax.type') || get(productLineData, 'tax.type')
      )*/

      // setFieldsValue({
      //   'tax.rate': get(line, 'tax.rate') || get(productLineData, 'tax.percentage') * (rate || 0),
      // })

      setTotal(rate * unit)
    }
  }, [productLineData._id, getFieldValue('productLine._id')])

  const rate = getFieldValue('rate') !== undefined && true ? getFieldValue('rate') : 0
  const unit = getFieldValue('unit') || 0
  const [total, setTotal] = useState(rate * unit)

  //console.log(rate)

  React.useEffect(() => {
    setTotal(rate * unit)

    setFieldsValue({
      'tax.rate': (rate * getFieldValue('tax.percentage')) / 100.0,
    })
  }, [rate, unit])

  const responseType = get(enquiry, 'responseType')
  const isResponseTypeSalesConfirmation = ['Sales Confirmation', 'Phone Sales'].includes(responseType)
  const isResponseTypeProductQuote = responseType === 'Product Quotation'

  return (
    <Form>
      <ProductModal
        {...{
          visible,
          modalType,
          product: {
            company,
            type,
            ...getFieldsValue(['category._id', 'group._id', 'product._id']),
            ...productDB,
          },
          submitting,
          submit,
          removing,
          remove,
          formRef,
          onShow,
          onCancel,
          update,
          setProduct,
          isNew: modalType === 'new',
        }}
      />

      {/*Company Stock Selection*/}
      <FormSectionTitle title={'PRODUCT SELECTION'} />
      <Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Category" style={{ width: '80%' }}>
            {getFieldDecorator('category._id', {
              initialValue: get(line, 'category._id'),
              rules: rules.select,
            })(
              <CategorySelect
                keyAtr={'_id'}
                valueAtr={'name'}
                placeholder={'Category'}
                setSelected={setCategoryObj}
                // onSelect={onSelectCategory}
              />
            )}
          </Form.Item>
        </Col>
        <Col span={12}>
          {getFieldValue('category._id') && (
            <Form.Item {...defaultFormItemLayout} label="Group" style={{ width: '80%' }}>
              {getFieldDecorator('group._id', {
                initialValue: get(line, 'group._id'),
                rules: rules.select,
              })(<GroupsSelect placeholder={'Group'} keyAtr={'_id'} valueAtr={'name'} />)}
            </Form.Item>
          )}
        </Col>
        {group && (
          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label={isStocked ? 'Stock' : 'Product'}>
              {getFieldDecorator('product._id', {
                initialValue: get(line, 'product._id'),
                //rules: rules.select,
              })(
                <ProductsTypeSelect style={{ width: '80%' }} placeholder={'Product'} keyAtr={'_id'} valueAtr={'name'} />
              )}
              <Icon style={{ marginLeft: 5 }} type="plus-circle" onClick={() => onShow({})} />
            </Form.Item>
          </Col>
        )}

        {productData && (isStocked || isService) && (
          <Col span={24}>
            <Form.Item {...fullWidthFormItemLayout} label="SKU">
              {getFieldDecorator('productLine._id', {
                initialValue: get(line, 'productLine._id'),
                //rules: rules.select,
              })(<ProductsSelect style={{ width: '80%' }} placeholder={'Product'} keyAtr={'_id'} valueAtr={'name'} />)}
            </Form.Item>
          </Col>
        )}
      </Row>

      {/*Client Enquiry Details*/}
      <FormSectionTitle title={'CLIENT ENQUIRY DETAILS'} />
      {(isResponseTypeSalesConfirmation || isResponseTypeProductQuote) && (
        <>
          <Row>
            <Col span={8}>
              <Form.Item
                {...threeFormItemLayout}
                style={{ width: '100%' }}
                label={<InfoTooltip value={'Line No'} title={'Use zero in front of numbers 0-9, ie: 01, 02'} />}>
                {getFieldDecorator('no', {
                  initialValue: get(line, 'no') || `${Max}`,
                  rules: rules.input,
                })(<Input placeholder={'Line No'} />)}
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item {...defaultFormItemLayout} label="Item Name">
                {getFieldDecorator('name', {
                  initialValue: get(line, 'name'),
                  rules: rules.input,
                })(<Input placeholder={'Name'} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={16}>
              <Form.Item {...fullWidthFormItemLayout} label={'Description'}>
                {getFieldDecorator('description', {
                  initialValue: get(line, 'description'),
                })(<TextArea placeholder={'Description'} />)}
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item {...defaultFormItemLayout} label="Delivery Days">
                {getFieldDecorator('delivery.no', {
                  initialValue: get(line, 'delivery.no') || get(enquiry, 'delivery.no') || deliveryDays,
                  rules: rules.select,
                })(<InputNumber placeholder={'Delivery Days'} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <h3>Rate Details</h3>
            <Taxes
              doc={line}
              {...{
                getFieldDecorator,
                getFieldValue,
                setFieldsValue,
                resetFields,
                type: 'saleLines',
                price: rate,
              }}
            />
          </Row>
          <Row>
            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label={'Quantity'}>
                {getFieldDecorator('unit', {
                  initialValue: get(line, 'unit') || 1,
                  rules: [
                    {
                      required: true,
                      message: 'Please Select a unit!',
                    },
                  ],
                })(
                  <Input
                    type="number"
                    style={{ width: '80%' }}
                    addonAfter={
                      <span>
                        {getFieldValue('uom.code') || get(line, 'uom.code') || get(line, 'productLine.uom.key')}
                      </span>
                    }
                    placeholder={'Quantity'}
                  />
                )}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label="UOM">
                {getFieldDecorator('uom.code', {
                  initialValue: get(line, 'uom.code'),
                  rules: rules.select,
                })(<UOM style={{ width: '80%' }} />)}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label={'Rate'}>
                {getFieldDecorator('rate', {
                  initialValue: get(line, 'rate'),
                  rules: rules.input,
                })(<InputNumber style={{ width: '80%' }} placeholder={'Rate'} />)}
              </Form.Item>
            </Col>
            {/*<Col span={8}>
              <Form.Item style={{ width: '120%' }} {...threeFormItemLayout} label={'Nominated OEM: '}>
                {getFieldDecorator('nominatedOEM', {
                  initialValue: get(line, 'nominatedOEM'),
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </Form.Item>
            </Col>*/}
          </Row>
          <Row>
            {!isService ? (
              <Col span={12}>
                <Form.Item {...defaultFormItemLayout} label={'Is Shippable'}>
                  {getFieldDecorator('isShippable', {
                    initialValue: get(line, 'isShippable', true),
                    valuePropName: 'checked',
                  })(<Checkbox value={get(line, 'isShippable')} />)}
                </Form.Item>
              </Col>
            ) : (
              <Col span={12} />
            )}
            <Col span={12}>
              <Form.Item {...defaultFormItemLayout} label={'TOTAL (NET)'}>
                <InputNumber style={{ width: '100%' }} disabled={true} value={total} placeholder={'Total'} />
              </Form.Item>
            </Col>
          </Row>
        </>
      )}

      {!isResponseTypeSalesConfirmation && !isResponseTypeProductQuote && (
        <>
          <Row>
            <Col span={8}>
              <Form.Item
                {...threeFormItemLayout}
                style={{ width: '100%' }}
                label={<InfoTooltip value={'Line No'} title={'Use zero in front of numbers 0-9, ie: 01, 02'} />}>
                {getFieldDecorator('no', {
                  initialValue: get(line, 'no') || `${Max}`,
                  rules: rules.input,
                })(<Input placeholder={'Line No'} />)}
              </Form.Item>
            </Col>
            <Col span={16}>
              <Form.Item {...defaultFormItemLayout} label="Item Name">
                {getFieldDecorator('name', {
                  initialValue: get(line, 'name'),
                  rules: rules.input,
                })(<Input placeholder={'Name'} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item
                {...{
                  labelCol: {
                    xs: { span: 24 },
                    sm: { span: 2 },
                    xxl: { span: 2 },
                  },
                  wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 22 },
                    xxl: { span: 22 },
                  },
                }}
                label={
                  <InfoTooltip value={'Description'} title={'Please input specifications of the required Item.'} />
                }>
                {getFieldDecorator('description', {
                  initialValue: get(line, 'description'),
                  rules: rules.input,
                })(<TextArea placeholder={'Please input specifications of the required Item.'} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={6}>
              <Form.Item {...threeFormItemLayout} label="Units (Qty)">
                {getFieldDecorator('unit', {
                  initialValue: get(line, 'unit'),
                  rules: rules.input,
                })(<InputNumber placeholder={'Units'} style={{ width: '100%' }} />)}
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item {...threeFormItemLayout} label="UoM">
                {getFieldDecorator('uom.code', {
                  initialValue: get(line, 'uom.code'),
                  rules: rules.select,
                })(<UOM />)}
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item style={{ width: '120%' }} {...threeFormItemLayout} label={'Nominated OEM: '}>
                {getFieldDecorator('nominatedOEM', {
                  initialValue: get(line, 'nominatedOEM'),
                  valuePropName: 'checked',
                })(<Checkbox />)}
              </Form.Item>
            </Col>
          </Row>
        </>
      )}

      {['MRO'].includes(type) && ['mroMaterials'].includes(get(categoryObj, 'code')) && (
        <MaterialDetails
          line={line}
          {...{
            getFieldDecorator,
            getFieldValue,
            setFieldsValue,
            resetFields,
            type: 'Enquiry',
          }}
        />
      )}
      {/* <>
            // CLIENT MATERIAL DETAILS
            <Row style={{backgroundColor: '#e6f7ff'}}>
              <Col span={12}>
                <span style={{margin: 5}}>
                  <b>Client Material Details</b>
                </span>
              </Col>
            </Row>
            <Row style={{backgroundColor: '#e6f7ff'}}>
              <Col span={8}>
                <Form.Item {...defaultFormItemLayout} label={'Stock No.'}>
                  {getFieldDecorator('materials.no', {
                    initialValue: get(line, 'materials.no'),
                  })(
                    <Input
                      placeholder={'Client Stock No.'}
                      style={{width: '80%'}}
                    />,
                  )}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item {...defaultFormItemLayout} label={'Client Ref.'}>
                  {getFieldDecorator('materials.clientRef', {
                    initialValue: get(line, 'materials.clientRef'),
                  })(
                    <Input
                      placeholder={'Client Ref:'}
                      style={{width: '80%'}}
                    />,
                  )}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item {...defaultFormItemLayout} label={'DWG No.'}>
                  {getFieldDecorator('materials.dwgNo', {
                    initialValue: get(line, 'materials.dwgNo'),
                  })(
                    <Input
                      placeholder={'Client DWG No.'}
                      style={{width: '80%'}}
                    />,
                  )}
                </Form.Item>
              </Col>
            </Row>

            OEM MATERIAL DETAILS
            <Row style={{backgroundColor: '#fff2e6'}}>
              <Col span={12}>
                <span style={{margin: 5}}>
                  <b>Nominated OEM / Vendor Details</b>
                </span>
              </Col>
            </Row>
            <Row style={{backgroundColor: '#fff2e6'}}>
              <Col span={8}>
                <Form.Item {...defaultFormItemLayout} label={'Part No.'}>
                  {getFieldDecorator('materials.oem.no', {
                    initialValue: get(line, 'materials.oem.no'),
                  })(<Input placeholder={'Part No.'} style={{width: '80%'}} />)}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item {...defaultFormItemLayout} label={'Name'}>
                  {getFieldDecorator('materials.oem.name', {
                    initialValue: get(line, 'materials.oem.name'),
                  })(<Input placeholder={'Name'} style={{width: '80%'}} />)}
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item {...defaultFormItemLayout} label={'DWG No.'}>
                  {getFieldDecorator('materials.oem.dwgNo', {
                    initialValue: get(line, 'materials.oem.dwgNo'),
                  })(<Input placeholder={'DWG No.'} style={{width: '80%'}} />)}
                </Form.Item>
              </Col>
            </Row>
          </>*/}
      {['Product'].includes(type) && ['Steel'].includes(categoryObj.code) && (
        <>
          <Row>
            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label="Material">
                {getFieldDecorator('product.fabrication.material', {
                  initialValue: get(line, 'product.fabrication.material'),
                })(<Input placeholder={'Material'} />)}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...threeFormItemLayout} label="Finish">
                {getFieldDecorator('product.fabrication.finish', {
                  initialValue: get(line, 'product.fabrication.finish'),
                })(<Input placeholder={'Finish'} />)}
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item {...fullWidthFormItemLayout} label="Notes">
                {getFieldDecorator('product.fabrication.notes', {
                  initialValue: get(line, 'product.fabrication.notes'),
                })(<TextArea rows={7} />)}
              </Form.Item>
            </Col>
          </Row>
        </>
      )}
      {['Product'].includes(type) && (
        <Row>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label="Delivery">
              {getFieldDecorator('delivery', {
                initialValue: get(line, 'delivery'),
              })(<DeliveryTypeSelect />)}
            </Form.Item>
          </Col>
        </Row>
      )}

      {['Service'].includes(type) && (
        <Row>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label="Service Delivery">
              {getFieldDecorator('Service.delivery', {
                initialValue: get(line, 'Service.delivery'),
              })(<DeliveryServiceTypeSelect />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'Period Start'}>
              {getFieldDecorator('Service.period.start', {
                initialValue: dateVal(line, 'Service.period.start'),
              })(<DatePicker />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item {...threeFormItemLayout} label={'Period End'}>
              {getFieldDecorator('Service.period.end', {
                initialValue: dateVal(line, 'Service.period.end'),
              })(<DatePicker />)}
            </Form.Item>
          </Col>
        </Row>
      )}
      {!isResponseTypeSalesConfirmation && !isResponseTypeProductQuote && (
        <>
          <Col span={24}>
            <Form.Item>
              <h4 style={{ marginBottom: 0 }}>Suggested Vendor(s)</h4>
            </Form.Item>
          </Col>
          <SuggestedVendors
            {...{
              getFieldDecorator,
              getFieldValue,
              doc: line,
            }}
          />
        </>
      )}
    </Form>
  )
}

EnquiriesLinesForm.propTypes = {}
EnquiriesLinesForm.defaultProps = { company: {} }

export default Form.create()(EnquiriesLinesForm)
